

/// <reference path="DBDocumentLine.ts" />

// Generated class SupplierInvoiceLine_ManagedObject

class SupplierInvoiceLine_ManagedObject extends DBDocumentLine
{
}
